import { render, staticRenderFns } from "./OrderComplain.vue?vue&type=template&id=2c3837d2&scoped=true"
import script from "./OrderComplain.vue?vue&type=script&lang=js"
export * from "./OrderComplain.vue?vue&type=script&lang=js"
import style0 from "./OrderComplain.vue?vue&type=style&index=0&id=2c3837d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3837d2",
  null
  
)

export default component.exports